(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    const button = document.getElementById('zestBTN')

  async function updateButtonStatus() {
    return fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {

        if (button) {
          button.disabled = false;
          button.title = '';
        }

        const hasGiftCards = cart.items.some(item => {
          return item.gift_card || /\b(?:gift[ _-]?card)\b/gi.test(item.product_type);
        });

        const hasSubscriptions = cart.items.some(item => {
          return item.selling_plan_allocation;
        });

        const errorTarget = hasGiftCards && hasSubscriptions
          ? "gift cards and subscriptions"
          : hasGiftCards ? "gift cards"
          : hasSubscriptions ? "subscriptions"
          : null;

        if (errorTarget) {
          if (button) {
            button.disabled = true;
            button.title = "We're sorry — " + errorTarget + " aren't eligible for this feature.";
          }
          return null;
        }

        return cart.token
      })

      .catch(error => {
        console.error('Error fetching cart:', error);
        return null
      });
  }

  button.addEventListener('click', async function() {
    const eligibleCartTokenResponse = await updateButtonStatus();

    if (eligibleCartTokenResponse) {
      window.location.href = 'https://' + Shopify.shop + '/apps/zest/start-multi-ship/' + eligibleCartTokenResponse;
    }
  });

  if (button) {
    updateButtonStatus();
  }
  } catch(e) { console.error(e); }
})();

})();
